<template>
    <div>
        <NavBar />
        <div class="container">
            <div class="row">
                <div class="col-sm-6">
                    <v-btn v-if="isStaff" @click="redirectToAdd"
                        class="btn btn-primary success">
                        Προσθηκη
                    </v-btn>
                </div>
            </div>
            <div class="col-sm-12">
                <v-data-table :headers="headers" :loading="loading" :items="items" item-key="id"
                    :server-items-length="totalItems" @pagination="onPagination"
                    :item-class="rowClass"
                    :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50, 100] }">
                    <template v-slot:item.invName="{ item }">
                        <span>{{ item.invName }}</span>
                        <v-chip v-if="isActive(item)" x-small color="success" class="ml-2" label>ΕΝΕΡΓΗ</v-chip>
                    </template>
                    <template v-slot:item.fromDate="{ item }">
                        {{ formatDateTime(item.fromDate) }}
                    </template>
                    <template v-slot:item.toDate="{ item }">
                        {{ formatDateTime(item.toDate) }}
                    </template>
                    <template v-slot:item.actionView="{ item }">
                        <v-btn v-if="!isStaff" color="success" small @click="setSelectedInvitation(item)">Αιτηση</v-btn>
                    </template>
                    <template v-slot:item.actionEdit="{ item }">
                        <div class="actionButs">
                            <v-btn v-if="isStaff" color="info" small
                                @click="edit(item)">{{ isAdmin ? 'Επεξεργασια' : 'Προβολη' }}</v-btn>
                            <v-btn v-if="isAdmin" color="error" small
                                :loading="deletingId === item.invitationId"
                                @click="deleteInvitation(item)">Διαγραφη</v-btn>
                        </div>
                    </template>
                </v-data-table>
            </div>
        </div>
    </div>
</template>

<script>
import NavBar from "./NavBar.vue";
import axios from "axios";
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";
import router from "../router";
import store from "../state/store";

export default {
    name: "InvAllList",
    components: { NavBar },

    data() {
        return {
            searchQuery: "",
            personSearch: [],
            items: [],
            totalPages: 0,
            rowsPerPageItems: [10, 20, 50],
            filteredPersons1: [],
            displayedItems: [],
            currentPage: 1,
            itemsPerPage: 10,
            perPage: 10,
            pagination: {
                page: 1,
                rowsPerPage: 10,
            },
            search: "",
            showAddForm: false,
            showEditForm: false,
            selectedItem: null,
            firstName: "",
            lastName: "",
            fatherName: "",
            loading: true,
            persons: [],
            selectedCategory: null,
            categoryName: "",
            editor: "",
            bio: "",
            totalItems: 0,
            origin: "",
            property: "",
            bibliography: "",
            searchItems: {
                firstName: "",
                lastName: "",
            },
            deletingId: null,
            headers: [
                { text: "Όνομα Πρόσκλησης", value: "invName" },
                { text: "Έναρξη Πρόσκλησης", value: "fromDate" },
                { text: "Λήξη Πρόσκλησης", value: "toDate" },
                { text: "Δράσεις", value: "actionView", sortable: false },
                { text: "", value: "actionEdit", sortable: false },
            ],
        };
    },

    computed: {
        userRole() {
            return this.$store.getters['user/getUserRole'];
        },
        isStaff() {
            return this.userRole === 'admin' || this.userRole === 'staff';
        },
        isAdmin() {
            return this.userRole === 'admin';
        }
    },

    mounted() {
        axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.user.token;
    },

    methods: {
        ...mapActions("person", ["showDetails", "editDetails", "editDetailsInv"]),
        ...mapGetters("user", ["getUserRole"]),
        ...mapGetters("invitation", ["getUserRole"]),
        isActive(item) {
            if (!item) return false;
            const now = new Date();
            const from = item.fromDate ? new Date(item.fromDate) : null;
            const to = item.toDate ? new Date(item.toDate) : null;
            return (!from || from <= now) && (!!to && to >= now);
        },
        rowClass(item) {
            return this.isActive(item) ? 'inv-active-row' : '';
        },
        formatDateTime(value) {
            if (!value) return '';
            const d = new Date(value);
            if (isNaN(d.getTime())) return value;
            const pad = n => String(n).padStart(2, '0');
            return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },
        async onPagination({ page, itemsPerPage = 10 }) {
            this.loading = true;
            console.log(page, itemsPerPage, this.searchQuery);
            if (this.searchQuery) {
                this.searchPersons(page, itemsPerPage);
            } else {
                this.getInvitationsPaged(page, itemsPerPage)
            }
        },

        async setSelectedInvitation(item) {
            await this.$store.dispatch("invitation/setSelectedInvitationAction", item).then(() => {
                router.push("/MySubmission");
            }).catch((error) => {
                console.error(error);
            });
        },

        async searchPersons(page, itemsPerPage) {
            try {
                axios.defaults.headers.common["Authorization"] =
                    "Bearer " + store.state.user.token;
                const response = await axios.get(
                    axios.defaults.baseURL +
                    `/invitation/invitation/search?query=${this.searchQuery}&page=${page - 1}&pageSize=${itemsPerPage}`
                );
                this.totalPages = response.data.totalPages;
                this.totalItems = response.data.totalElements;
                this.items = response.data.content;
                this.loading = false;
                console.log(this.totalItems);
            } catch (error) {
                console.log(error);
            }
        },

        async getInvitationsPaged(page, itemsPerPage) {
            axios.defaults.headers.common["Authorization"] =
                "Bearer " + store.state.user.token;
            axios
                .get(
                    axios.defaults.baseURL +
                    `/invitation/invitationPaged?page=${page - 1}&size=${itemsPerPage}`
                )
                .then((response) => {
                    console.log(response);
                    // Sort: active invitations (current time within
                    // fromDate–toDate) appear first; the rest follow,
                    // newest toDate first.
                    const now = new Date();
                    const content = (response.data.content || []).slice();
                    content.sort((a, b) => {
                        const aActive = new Date(a.fromDate) <= now && new Date(a.toDate) >= now;
                        const bActive = new Date(b.fromDate) <= now && new Date(b.toDate) >= now;
                        if (aActive !== bActive) return aActive ? -1 : 1;
                        return new Date(b.toDate) - new Date(a.toDate);
                    });
                    this.items = content;
                    this.totalPages = response.data.totalPages;
                    this.totalItems = response.data.totalElements;
                    this.loading = false;
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        show(item) {
            this.showDetails(item);
        },

        edit(item) {
            this.editDetailsInv(item);
        },

        redirectToAdd() {
            this.$router.push("/addInv");
        },
        async deleteInvitation(item) {
            const subsWarning =
                "\u03a4\u03c5\u03c7\u03cc\u03bd \u03b1\u03b9\u03c4\u03ae\u03c3\u03b5\u03b9\u03c2 \u03c0\u03bf\u03c5 \u03c3\u03c5\u03bd\u03b4\u03ad\u03bf\u03bd\u03c4\u03b1\u03b9 \u03bc\u03b5 \u03b1\u03c5\u03c4\u03ae\u03bd \u03c4\u03b7\u03bd \u03c0\u03c1\u03cc\u03c3\u03ba\u03bb\u03b7\u03c3\u03b7 \u03b8\u03b1 \u03b4\u03b9\u03b1\u03b3\u03c1\u03b1\u03c6\u03bf\u03cd\u03bd \u03b5\u03c0\u03af\u03c3\u03b7\u03c2.";
            const confirmed = await Swal.fire({
                title: `\u0394\u03b9\u03b1\u03b3\u03c1\u03b1\u03c6\u03ae \u03c0\u03c1\u03cc\u03c3\u03ba\u03bb\u03b7\u03c3\u03b7\u03c2 "${item.invName}";`,
                html: subsWarning + "<br/>\u0397 \u03b5\u03bd\u03ad\u03c1\u03b3\u03b5\u03b9\u03b1 \u03b4\u03b5\u03bd \u03b1\u03bd\u03b1\u03b9\u03c1\u03b5\u03af\u03c4\u03b1\u03b9.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "\u039d\u03b1\u03b9, \u03b4\u03b9\u03b1\u03b3\u03c1\u03b1\u03c6\u03ae",
                cancelButtonText: "\u0386\u03ba\u03c5\u03c1\u03bf",
                confirmButtonColor: "#d33",
            });
            if (!confirmed.isConfirmed) return;

            this.deletingId = item.invitationId;
            try {
                axios.defaults.headers.common["Authorization"] =
                    "Bearer " + store.state.user.token;
                await axios.delete(
                    axios.defaults.baseURL + "/invitation/" + item.invitationId
                );
                await Swal.fire({
                    icon: "success",
                    title: "\u0397 \u03c0\u03c1\u03cc\u03c3\u03ba\u03bb\u03b7\u03c3\u03b7 \u03b4\u03b9\u03b1\u03b3\u03c1\u03ac\u03c6\u03b7\u03ba\u03b5",
                    timer: 1800,
                    timerProgressBar: true,
                    showConfirmButton: false,
                });
                this.getInvitationsPaged(this.currentPage, this.itemsPerPage);
            } catch (error) {
                console.error(error);
                const status = error && error.response && error.response.status;
                await Swal.fire({
                    icon: "error",
                    title: "\u03a3\u03c6\u03ac\u03bb\u03bc\u03b1 \u0394\u03b9\u03b1\u03b3\u03c1\u03b1\u03c6\u03ae\u03c2",
                    text: status === 403
                        ? "\u0394\u03b5\u03bd \u03ad\u03c7\u03b5\u03c4\u03b5 \u03b4\u03b9\u03ba\u03b1\u03af\u03c9\u03bc\u03b1 \u03b4\u03b9\u03b1\u03b3\u03c1\u03b1\u03c6\u03ae\u03c2."
                        : "\u0397 \u03b4\u03b9\u03b1\u03b3\u03c1\u03b1\u03c6\u03ae \u03b1\u03c0\u03ad\u03c4\u03c5\u03c7\u03b5.",
                });
            } finally {
                this.deletingId = null;
            }
        },
        async Delete(item) {
            const confirmed = await Swal.fire({
                title: `Είσαι σίγουρος ότι θέλεις να διαγράψεις: ${item.invName}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Ναί, διαγραφή!",
                cancelButtonText: "Όχι",
                reverseButtons: false,
            });
            if (confirmed.isConfirmed) {
                axios
                    .post(axios.defaults.baseURL + "/invitation/deleteInvitation", item)
                    .then(async (response) => {
                        console.log(response.data);
                        if (response.data === true) {
                            await Swal.fire({
                                icon: "success",
                                title: "Επιτυχής Διαγραφή",
                                text: "Η πρόσκληση διαγράφτηκε επιτυχώς.",
                                timer: 2000,
                                timerProgressBar: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                                showConfirmButton: false
                            });
                            this.getInvitationsPaged(this.pagination.page, this.itemsPerPage);
                        } else {
                            await Swal.fire({
                                icon: "error",
                                title: "Ανεπιτυχής Διαγραφή",
                                text: "Η πρόσκληση διαγράφτηκε ανεπιτυχώς.",
                                timer: 2000,
                                timerProgressBar: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                                showConfirmButton: false
                            });
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        alert("Failed to fetch categories");
                    });
            }
        },
    },
};
</script>

<style scoped>
/* Visually highlight invitations that are currently active */
::v-deep .inv-active-row {
    background-color: #e8f5e9 !important;
}
::v-deep .inv-active-row:hover {
    background-color: #d8efdb !important;
}

.actionButs {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: nowrap;
    white-space: nowrap;
}
.actionButs .v-btn {
    min-width: 110px;
}

footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 5%;
    background-color: #000000 !important;
    color: #ffffff;
    text-align: right !important;
}

.container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
}

.v-data-table__wrapper {
    overflow-x: auto;
}

.v-data-table__wrapper table {
    width: 100%;
    white-space: nowrap;
}

.v-data-table__wrapper td {
    padding: 16px;
    text-overflow: ellipsis;
    vertical-align: middle;
}

@media (max-width: 767px) {
    .container {
        padding: 10px;
    }

    .v-data-table__wrapper th {
        font-size: 12px;
        font-weight: 500;
        white-space: nowrap;
    }

    .v-data-table__wrapper td {
        font-size: 14px;
        white-space: nowrap;
    }
}
</style>